import RealEstateRatesPage from '@playground/features/dictionary/RealEstateRatesPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_app/_superAdmin/dictionary/real-estate-rates'
)({
  component: RealEstateRatesPage,
})
